<script setup lang="ts">
import IconBarCode from '~/components/icons/IconBarCode.vue'
import { getDateWithTime } from '~/utils/day-js'

defineOptions({
	name: 'TicketScannerTicket',
})

interface Props {
	isScanning?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	isScanning: false,
})

const { t: $t, locale } = useI18n()

const ticketNumbers = [
	'05',
	'56',
	'46',
	'69',
	'12',
	'34',
	'27',
	'51',
	'08',
	'42',
	'19',
	'75',
	'23',
	'60',
	'31',
	'0',
	'0',
	'0',
]

const getPriceTicket = computed(() => {
	if (locale.value === 'fr') return '$5.00'
	if (locale.value === 'pt') return '€ 5,00'
	return '5,00 €'
})
</script>

<template>
	<div class="ticket-card relative overflow-hidden">
		<!-- Scan line -->
		<div
			v-if="props.isScanning"
			class="scan-line"
		/>
		<NuxtImg
			src="/cdn/header_ticket.webp"
			alt="Confetti"
			loading="lazy"
			title="Confetti"
			class="w-full h-16"
		/>

		<!-- Header -->
		<div class="px-5 py-6 text-center">
			<div class="flex items-center justify-center gap-2 mb-1">
				<UIcon
					name="heroicons:sparkles"
					class="w-3.5 h-3.5 text-primary"
				/>

				<span class="text-[8px] smm:text-xs font-extrabold tracking-[0.18em] text-primary uppercase">{{
					$t('Your Ticket')
				}}</span>
				<UIcon
					name="heroicons:sparkles"
					class="w-3.5 h-3.5 text-primary"
				/>
			</div>
			<!-- <p class="text-[10px] text-gray-400 tracking-widest uppercase">Mega Sena • Pending</p> -->
		</div>

		<!-- ID + Price -->
		<div
			class="px-5 py-4 flex justify-between items-center font-bold leading-3 text-[#F2F2F2]/70 text-[6px] smm:text-[10px]"
		>
			<span>#LOT-9876543</span>
			<span>{{ getPriceTicket }}</span>
		</div>
		<div class="mx-5 border-b border-[#282C33]" />

		<!-- Numbers grid -->
		<div class="px-5 smm:pb-4 pt-5 smm:pt-10">
			<div class="p-3 sm:p-0">
				<div class="grid grid-cols-4 gap-y-2 gap-x-0.5 text-center">
					<div
						v-for="(num, idx) in ticketNumbers"
						:key="idx"
						class="flex justify-center text-[#2EB860]"
						:class="{ invisible: num === '0' }"
					>
						<span class="text-xs sm:text-lg font-extrabold tabular-nums">
							{{ num !== '0' ? String(num).padStart(2, '0') : '0' }}
						</span>
					</div>
				</div>
			</div>
		</div>

		<!-- Date -->
		<div class="px-5 pb-3 flex justify-between text-[8px] smm:text-[10px] text-[#818898]">
			<span>{{ $t('Date') }}</span>
			<span class="font-medium text-neutral-100/70 capitalize">{{
				getDateWithTime('2026-03-19T21:00:00', locale)
			}}</span>
		</div>

		<!-- Barcode area -->
		<div class="px-5 pt-3 pb-5 flex flex-col items-center gap-1">
			<IconBarCode class="w-28 smm:w-40 h-4 smm:h-6 text-neutral-50" />

			<p class="text-[6px] smm:text-[8px] font-mono tracking-[0.22em] text-gray-400">78962450192</p>
		</div>
	</div>
</template>
